import React from 'react'

import './styles.scss'

const bs = 'activity-loader'

const ActivityLoader = () => (
  <div className={bs}>
    <div className={`${bs}__header`}>
      <div
        className="loader-row"
        style={{
          width: '124px',
          height: '32px',
        }}
      />
      <div
        className="loader-row"
        style={{
          width: '97px',
          height: '32px',
          borderRadius: '4px',
        }}
      />
    </div>
    <div
      className="loader-row"
      style={{
        width: '100%',
        height: '20px',
        marginBottom: '10px',
      }}
    />
    <div
      className="loader-row"
      style={{
        width: '100%',
        height: '20px',
        marginBottom: '10px',
      }}
    />
    <div
      className="loader-row"
      style={{
        width: '80%',
        height: '20px',
        marginBottom: '30px',
      }}
    />
    <div
      className="loader-row"
      style={{
        width: '100%',
        height: '180px',
      }}
    />
  </div>
)

export default ActivityLoader
